import React from 'react';
import { motion } from 'framer-motion';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <motion.div initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.5
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`max-w-2xl ${isCenter ? 'mx-auto text-center' : ''}`} data-id="element-317" data-mp="3k0yjaffwbfce">
      <div className={`flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`} data-id="element-318" data-mp="1vc05p3egz38">
        <span className="h-px w-8 bg-gold/70" aria-hidden="true" data-id="element-319" data-mp="6svc2icmkzs0" />
        <span className="font-sans text-[11px] uppercase tracking-[0.32em] text-gold" data-id="element-320" data-mp="uj7tqkxoaavs">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-4 font-display text-3xl uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-321" data-mp="za7objjbkgv4">
        {title}
      </h2>
      {description ? <p className="mt-4 max-w-xl text-sm leading-relaxed text-ash sm:text-base" data-id="element-322" data-mp="1ob4iuz6rn22l">
          {description}
        </p> : null}
    </motion.div>;
}